export default "__VITE_ASSET__Bg3NnO3I__"